import { ErrorReminderProps } from '@my-types';
import { React, Styled, StyledF } from '@common/3rd';
import { StyledComponents } from '@styles';

const FadeOut = StyledF.keyframes`
	0%, 80% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
`;

const Reminder = Styled(StyledComponents.FAS)`
	height: ${props => props.theme.INPUT_HEIGHT}px;
	/* 图标比较小, 向下靠一点 */
	line-height: ${props => props.theme.INPUT_HEIGHT + 4}px;
	width: ${props => props.theme.INPUT_LINE_HEIGHT}px;
	font-size: ${props => props.theme.FONT_SIZE_SMALL}px;
	cursor: pointer;
`;
const ForError = Styled(Reminder)`
	color: ${props => props.theme.COLOR_ERROR};

	> span {
		display: inline-block;
		position: absolute;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		max-width: 400px;
		min-width: 100px;
		min-height: 20px;
		line-height: ${props => props.theme.INPUT_HEIGHT - 10}px;
		// bottom: calc(100% - 6px);
		// right: 6px;
		top: ${props => props.theme.INPUT_HEIGHT}px;
		left: ${props => props.theme.DESK_CELL_INNER_LABEL_WIDTH + 10}px;
		// background-color: ${props => props.theme.COLOR_ERROR};
		color: ${props => props.theme.COLOR_ERROR}; // ${props => props.theme.COLOR_REVERSED};
		padding: 3px ${props => props.theme.BTN_HORIZONTAL_PADDING}px;
		// border: ${props => props.theme.BORDER};
		// border-color: ${props => props.theme.COLOR_ERROR};
		// border-radius: 10px;
		border-bottom-right-radius: ${props => props.theme.BORDER_RADIUS}px;
		// animation-duration: ${props => props.theme.ERROR_REMINDER_FADE_OUT_DURATION};
		// animation-fill-mode: both;
		// animation-name: ${FadeOut};
		user-select: none;
		z-index: 1;
		cursor: default;
	}

	&:hover > span {
		opacity: 1;
		animation-name: none;
	}
`;

const ForPass = Styled(Reminder)`
	color: ${props => props.theme.COLOR_SUCCESS};
`;

export const ErrorReminder = class extends React.Component<ErrorReminderProps> {
	render() {
		return (
			<ForError icon="exclamation-circle" data-widget="error-reminder">
				<span>{this.props.msg}</span>
			</ForError>
		);
	}
};
export const PassReminder = class extends React.Component {
	render() {
		return <ForPass icon="check-circle" data-widget="pass-reminder" />;
	}
};
